import { useState } from "react";
import FPAImageUploadModal from "../Modals/FPAImageUploadModal";
import useFPAFileUpload from "./useFPAFileUpload";
import ImageUploadMinimized from "../Dashboard/ImageUploadMinimized";
import { useSelector } from "react-redux";
import UploderClosinWarning from "../UploaderClosingWarning";

const FPAFileUpload = () => {
  const { FPAupload } = useSelector((state) => state);

  const {
    handleImageChange,
    openUploadFPAModal,
    handleDragOver,
    handleDrop,
    handleDragOut,
    closeUploadModal,
    uploadReadyImages,
    validImages,
    handleCloseFPAMiniMizedModal,
    uploadWarning,
    setUploadWarning,
    handleQuitUploading,
    uploadResponses,
    currentlyUploading,
    fileInputRef,
    fileUploadState,
  } = useFPAFileUpload();

  return (
    <>
      <FPAImageUploadModal
        fileInputRef={fileInputRef}
        showModal={openUploadFPAModal}
        setShowModal={closeUploadModal}
        handleDragOver={handleDragOver}
        handleDragOut={handleDragOut}
        handleDrop={handleDrop}
        handleImageChange={handleImageChange}
        closeUploadModal={closeUploadModal}
        uploadReadyImages={uploadReadyImages}
        uploadResponses={uploadResponses}
        currentlyUploading={currentlyUploading}
        fileUploadState={fileUploadState}
      />
      {FPAupload.openFPAMiniBox && (
        <ImageUploadMinimized
          setIsShowImageUpload={handleCloseFPAMiniMizedModal}
          uploadReadyImages={uploadReadyImages}
          validImages={validImages}
          uploadResponses={uploadResponses}
          currentlyUploading={currentlyUploading}
        />
      )}

      <UploderClosinWarning
        uploadAlert={uploadWarning}
        setUploadAlert={setUploadWarning}
        handleQuitUploading={handleQuitUploading}
      />
    </>
  );
};
export default FPAFileUpload;
